import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { dateDisplayFormater, dateDisplayFormaterwithTime, dateDisplayFormaterwithTimewithoutsec } from "../../../Utils";
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import { InvoiceNotesAction } from "../../../Reducer/InvoiceNotesReducer";
export default function InvoiceSummaryNotes({ invoiceId, StatusId, InvoiceNumber, saveAfter }) {
    const state = useSelector(state => state);
    const formRef = useRef();
    const { fetchData } = useFetchWithCancellation();
    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    // const [statusId, setstatusId] = useState(0);
    const [showAddNotes, setshowAddNotes] = useState(false);
    const [inputValues, setInputValues] = useState({
        fkInvoiceId: 0,
        User: "",
        UserId: 0,
        CreatedDate: new Date(),
        UserNotes: "",
        statusId: 0,
        invoiceNumber: InvoiceNumber
    });
    const [invoiceNotes, setInvoiceNotes] = useState([]);
    const [isInvNotes, setIsInvNotes] = useState(false);
    const [data, setData] = useState({
        fkInvoiceId: 0,
        StatusId: 0,
       // UserId: 0,
        CreatedDate: new Date(),
        SystemNotes: "",
        UserNotes: "",
    });

    useEffect(() => {
        if (state.invIDNote.length > 0) {
            var loggedInUser = JSON.parse(localStorage.getItem("user"));
            setInputValues(input => ({ ...input, fkInvoiceId: invoiceId, User: loggedInUser.name, UserId: loggedInUser.Id, statusId: StatusId }));
            // setData(dat => ({ ...dat, fkInvoiceId: state.invIDNote, UserId: loggedInUser.Id }));
        }
    }, []);


    useEffect(() => {
        setInvoiceNotes(state.invIDNote);
    },[isInvNotes])

    useEffect(() => {
        dispatch({ type: InvoiceNotesAction.RemInvIDForNotes });
      
        fetchData(state.projectdetail.API + "/invoiceNotes/Get?Id="+invoiceId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
           // body: JSON.stringify(obj)
        }).then(response => response.json()).then((res) => {
            if (res) {
                if (res.length > 0) {
                    for (let i = 0; i < res.length; i++)
                    {

                        dispatch({ type: InvoiceNotesAction.AddInvIDForNotes, payload: res[i] });
                    }  
                    setIsInvNotes(!isInvNotes);
                }
               // setData(res);
                
               }
            else {
                window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }
        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("PCPInvoiceNotes.js ==> Invoice notes save", null, null, err);
            window.alert(state.projectdetail.ErrorMessage);
        }).finally(() => {
            // setLoading(false);
            // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
        });

    }, []);
    const handleChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        if (e.target.value) {
            setInputValues(d => ({ ...d, [name]: value }));
        }
    }

    const SaveData = () => {
       // console.log("Save Data");
        // console.log(data);
        if (inputValues && inputValues.UserNotes.length == 0) {
            window.alert("Please enter Notes", function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            document.getElementById("UserNotes").focus();
            return false;
        }
        var loggedInUser = JSON.parse(localStorage.getItem("user"));
        //setInputValues(input => ({ ...input, fkInvoiceId: invoiceId, User: loggedInUser.name, UserId: loggedInUser.Id, statusId: StatusId }));
        if (inputValues && inputValues.fkInvoiceId > 0) {

            let obj = new Object();
            obj.fkInvoiceId = invoiceId;
            obj.StatusId = StatusId;
            obj.UserNotes = inputValues.UserNotes;
            obj.CreatedBy = loggedInUser.Id;
            obj.ModifiedBy = loggedInUser.Id;
            // obj.isActive = 1;

            fetchData(state.projectdetail.API + "/invoiceNotes/Save?Status=", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj)
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    res.Data.CreatedDate = new Date(res.Data.CreatedDate);
                    setInputValues(res.Data);
                    window.toast("Invoice notes saved sucessfully");
                    dispatch({ type: InvoiceNotesAction.RemInvIDForNotes });
                    setValidated(false);
                    setIsInvNotes(!isInvNotes);
                    // setSavedSuccessfully(true);
                    saveAfter(false);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("PCPInvoiceNotes.js ==> Invoice notes save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                saveAfter();
                // setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
            });

        }
    }
    const AddNotes = () => {
        setshowAddNotes(true);
       // console.log("showAddNotes :" + showAddNotes);
    }
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>

                {/*<div>*/}
                {/*    Invoice Notes Screen : {state.invIDNote}*/}
                {/*</div>*/}
                <Row>
                    <Col>
                        <Card className="border">
                            <Card.Body>
                                <Row>
                                   
                                    <Col><b>Invoice Number : </b>{inputValues.invoiceNumber}</Col>
                                </Row>
                                <Row>
                                    <Table>
                                        <thead border="1" className="table-light">
                                        <th>Sl.No </th>
                                        <th>User</th>
                                            <th> Notes</th>
                                        {/*<th>User Notes</th>*/}
                                        <th>Date</th>
                                        </thead>
                                        <tbody>
                                            {invoiceNotes && invoiceNotes.map((note, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td width='80px'>{note.UserName}</td>
                                                    <td>{note.SystemNotes}</td>
                                                    {/*<td>{note.UserNotes}</td>*/}
                                                    {note.CreatedDate &&
                                                        <td>{dateDisplayFormaterwithTimewithoutsec(note.CreatedDate)}</td>
                                                    }
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    
                                   
                                        <Row>
                                            <Col md={9}></Col>
                                            <Col md={3}>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;
                                                <Button variant="primary"
                                                    style={{ align: 'left' }}
                                                    onClick={AddNotes}>
                                                    Add Notes
                                                </Button>
                                            </Col>

                                        </Row>
                                </Row>
                                
                                {showAddNotes && (
                                <Row md={12}>
                                    <Col md={6}>
                                        <div><Form.Group>
                                            <Form.Label>User:</Form.Label>
                                            <Form.Control type="text" name="User" value={inputValues.User} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                    <Col md={3}></Col>
                                    <Col md={3}>
                                        <div><Form.Group>
                                            <Form.Label>Date:</Form.Label>
                                            <Form.Control type="text" name="CreatedDate" value={dateDisplayFormater(inputValues.CreatedDate)} disabled autoComplete="off" />
                                        </Form.Group></div>
                                    </Col>
                                </Row>
                                )}
                                {showAddNotes && (
                                <Row>
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Notes<code className='required-symbol'></code></Form.Label>
                                                <Form.Control as="textarea" rows={10} id="UserNotes" name="UserNotes" onChange={(e) => { handleChange(e) }}
                                                value={inputValues.UserNotes} autoComplete="off" placeholder="Enter notes here..." />
                                        </Form.Group>
                                    </Col>
                                    </Row>
                                )}
                                {showAddNotes && (
                                    <Row>
                                        <p></p>

                                    </Row>
                                )}
                                {showAddNotes && (
                                    <Row>
                                        <Col md={10}></Col>
                                        <Col md={2}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;
                                            <Button variant="primary"
                                                style={{ align: 'left' }}
                                                onClick={SaveData}>
                                                Save
                                            </Button>
                                        </Col>

                                    </Row>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Form>
    </ErrorBoundary>
    )

}